export default __webpack_public_path__ + "static/media/springBoot.8a706677.webp";